import React from "react";
import { useContext } from "../../../../../context";

export function Header({ onClose }) {
  const { appointment } = useContext();

  return (
    <div className="newPopupTitle">
      <div className="popup-name">
        {appointment.patient?.fullName} -{" CHECK IN"}
      </div>
      <button className="popupClose" onClick={onClose}>
        <img alt="" src="/images/close.png" />
      </button>
    </div>
  );
}
